import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useModal } from 'react-brave-modal';

import { usePatient } from '../../../../../hooks/patient';

import CheckOkImage from '../../../../../assets/images/check-ok-2.svg';
import Button from '../../../../../components/Button';

import { Container } from './styles';

interface FinishPatientRegisterModalProps {
  /**
   * Instituição em que o paciente nasceu (0.31). Opcional para não quebrar quem abrir o
   * modal sem ela — mas o cadastro sempre a manda, e para o `administrator`, que desde a
   * 0.30 escolhe entre municípios, é a única confirmação de que o paciente foi para o
   * tenant certo.
   */
  institutionName?: string;
  /**
   * E-mail que recebeu o convite de boas-vindas (0.33). Opcional pelo mesmo motivo do
   * `institutionName` — quem abrir o modal sem ele não quebra —, mas o cadastro sempre o
   * manda, porque o e-mail passou a ser obrigatório.
   */
  email?: string;
}

const FinishPatientRegisterModal: React.FC<FinishPatientRegisterModalProps> = ({
  institutionName,
  email,
}) => {
  const history = useHistory();
  const { closeModal } = useModal();
  const { patient } = usePatient();

  const handleCheckout = useCallback(() => {
    history.push('/patient/list');
    closeModal();
  }, [closeModal, history]);

  const handleProceed = useCallback(() => {
    history.push(`/patient/profile?id=${patient?.id}`);
    closeModal();
  }, [closeModal, history, patient]);

  return (
    <Container>
      <img src={CheckOkImage} alt="Imagem de sucesso" />
      <h1>O Perfil do paciente foi cadastrado com sucesso!</h1>
      <p>
        Agora, o perfil do paciente está ativo e já pode receber agendamentos.
      </p>
      {institutionName && <strong>{`Instituição: ${institutionName}`}</strong>}
      {/*
        O paciente **não sai daqui com acesso ao aplicativo**: ele recebe um convite por
        e-mail, e é lá que cria a senha e aceita o termo de consentimento. Dizer isto na tela
        é o que evita a pergunta "e a senha dele, qual é?" — que antes da 0.33 não tinha
        resposta, porque a senha era sorteada e descartada.
      */}
      {email && (
        <p>
          {`Enviamos um e-mail de boas-vindas para ${email} com o link para o paciente criar a senha de acesso ao aplicativo. O link vale por 7 dias e pode ser reenviado pela listagem de pacientes.`}
        </p>
      )}

      <div>
        <Button buttonType="primary" onClick={handleProceed}>
          Ver perfil
        </Button>
        <Button buttonType="primary-alternative" onClick={handleCheckout}>
          Ver pacientes
        </Button>
      </div>
    </Container>
  );
};

export default FinishPatientRegisterModal;
